const WORD_PATTERN = /[A-Za-z0-9]+(?:'[A-Za-z0-9]+)?/g;

const countWords = (value) => {
  if (!value) {
    return 0;
  }

  const matches = String(value).match(WORD_PATTERN);
  return matches ? matches.length : 0;
};

export const estimateReadTimeFromSections = (sections, extraText = []) => {
  const totalWords = (sections || []).reduce((runningTotal, section) => {
    let sectionWords = countWords(section.title);

    (section.paragraphs || []).forEach((paragraph) => {
      sectionWords += countWords(paragraph);
    });

    (section.bullets || []).forEach((bullet) => {
      sectionWords += countWords(bullet);
    });

    (section.ordered || []).forEach((orderedItem) => {
      sectionWords += countWords(orderedItem);
    });

    (section.subSections || []).forEach((subSection) => {
      sectionWords += countWords(subSection.title);
      (subSection.paragraphs || []).forEach((paragraph) => {
        sectionWords += countWords(paragraph);
      });
    });

    (section.commands || []).forEach((commandBlock) => {
      sectionWords += countWords(commandBlock.title);
      sectionWords += countWords(commandBlock.command);
    });

    (section.commandsAfter || []).forEach((commandBlock) => {
      sectionWords += countWords(commandBlock.title);
      sectionWords += countWords(commandBlock.command);
    });

    sectionWords += countWords(section.diagram);
    sectionWords += countWords(section.yaml);
    sectionWords += countWords(section.nginx);

    return runningTotal + sectionWords;
  }, extraText.reduce((runningTotal, text) => runningTotal + countWords(text), 0));

  return Math.max(1, Math.ceil(totalWords / 190));
};
